// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ps9y","input":"styles_input__1AsrO"};